import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Tarifa } from './tarifa';
import { ActivatedRoute } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-tarifa-update',
  templateUrl: './tarifa-update.component.html'
})
export class TarifaUpdateComponent
 extends BaseUpdateComponent<Tarifa> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Sifra", Validators.required, 'required', 'TARIFA.SIFRA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Sifra", Validators.maxLength(3), 'maxlength', 'TARIFA.SIFRA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'TARIFA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'TARIFA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("UnCode", Validators.required, 'required', 'TARIFA.UNCODE.VALIDATION.REQUIRED');
    this.addValidatorToFc("UnCode", Validators.maxLength(2), 'maxlength', 'TARIFA.UNCODE.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("DrzavaID", Validators.required, 'required', 'TARIFA.DRZAVA.VALIDATION.REQUIRED');
    this.addValidatorToFc("EName", Validators.required, 'required', 'TARIFA.ENAME.VALIDATION.REQUIRED');
    this.addValidatorToFc("EName", Validators.maxLength(3), 'maxlength', 'TARIFA.ENAME.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("ETaxTypeCode", Validators.required, 'required', 'TARIFA.ETAXTYPECODE.VALIDATION.REQUIRED');
    this.addValidatorToFc("ETaxTypeCode", Validators.maxLength(30), 'maxlength', 'TARIFA.ETAXTYPECODE.VALIDATION.MAXLENGTH');


  }

}
